export const TRANSFER_GROUP = {
  SENT: 'sent',
  RECEIVED: 'received',
};
